import React, { useEffect } from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { InfinitySpin } from "react-loader-spinner";
import { Empty } from "antd";
import { Link, useNavigate } from "react-router-dom";
import { useConnectionProvider } from "../../../../../Providers/Vendor/Connections";
import CustomTable from "../../../../../Components/Table";
import Back from "../../../../../Components/Back";
import { Avatar } from "@mui/material";
import { stringAvatar } from "../../../../../Utils/avatar";

const headCells = [
  { label: "Vendor" },
  { label: "Status" },
  // { label: "Number Of Consultants" },
  { label: "" },
];

export default function Vendors({ setCard }) {
  const navigate = useNavigate();
  const {
    loading,
    vendorsWithCount,
    vendors,
    fetchVendors,
    fetchVendorsWithConsultantCount,
  } = useConnectionProvider();

  useEffect(() => {
    fetchVendors();
    // fetchVendorsWithConsultantCount();
  }, []);

  const CustomRow = ({ row }) => {
    return (
      <TableRow hover tabIndex={-1} key={row.id}>
        <TableCell component="th" scope="row">
          <Link target="_blank" to={`/vendor/profile/${row.vendor_id || row.id}`}>
            <span className="flex flex-row items-center">
              <Avatar
                {...stringAvatar(
                  row.companyName
                    ? row.companyName
                    : row.firstName
                      ? `${row.firstName} ${row.lastName}`
                      : row.email
                )}
                className="mr-2.5"
                size="large"
                src={row?.profilePhoto}
              />
              {row.companyName}
            </span>
          </Link>
        </TableCell>
        <TableCell align="left">Current</TableCell>
        {/* <TableCell align="left">{row.consultantCount}</TableCell> */}
        <TableCell align="left">
          <Link target="_blank" to={"/vendor/profile/" + row?.vendor_id || row?.id}>
            <span className="text-blue-400 hover:cursor-pointer">
              View Details
            </span>
          </Link>
        </TableCell>
      </TableRow>
    );
  };

  const CustomEmpty = () => (
    <div className="flex justify-center py-4">
      {loading ? <InfinitySpin width="200" color="#4fa94d" /> : <Empty />}
    </div>
  );

  return (
    <>
      <Back onClick={() => {
        navigate("/dashboard")
      }} />
      <CustomTable
        title="Vendors"
        headCells={headCells}
        rows={vendors.filter((vendor) => vendor.status === "Current")}
        CustomRow={CustomRow}
        CustomEmpty={CustomEmpty}
      />
    </>
  );
}
